
import { WorldCountry } from '../types';

export const newZealand: WorldCountry = {
  code: 'NZ',
  name: 'New Zealand',
  slug: 'new-zealand',
  population: 4822233,
  topCities: [
    { name: 'Auckland', slug: 'auckland', population: 1695200 },
    { name: 'Wellington', slug: 'wellington', population: 418500 },
    { name: 'Christchurch', slug: 'christchurch', population: 383200 },
    { name: 'Hamilton', slug: 'hamilton-nz', population: 179000 },
    { name: 'Tauranga', slug: 'tauranga', population: 158800 },
    { name: 'Napier-Hastings', slug: 'napier-hastings', population: 141300 },
    { name: 'Dunedin', slug: 'dunedin', population: 133700 },
    { name: 'Palmerston North', slug: 'palmerston-north', population: 91900 },
    { name: 'Nelson', slug: 'nelson-nz', population: 53900 },
    { name: 'Queenstown', slug: 'queenstown', population: 53800 },
    
    // Expansión: 90 ciudades adicionales para llegar a 100 total
    { name: 'Rotorua', slug: 'rotorua', population: 79000 },
    { name: 'New Plymouth', slug: 'new-plymouth', population: 87200 },
    { name: 'Whangarei', slug: 'whangarei', population: 89200 },
    { name: 'Invercargill', slug: 'invercargill', population: 54200 },
    { name: 'Whanganui', slug: 'whanganui', population: 43900 },
    { name: 'Gisborne', slug: 'gisborne', population: 37700 },
    { name: 'Timaru', slug: 'timaru', population: 30000 },
    { name: 'Oamaru', slug: 'oamaru', population: 13900 },
    { name: 'Blenheim', slug: 'blenheim', population: 31000 },
    { name: 'Masterton', slug: 'masterton', population: 25200 },
    { name: 'Levin', slug: 'levin', population: 21000 },
    { name: 'Whakatane', slug: 'whakatane', population: 19900 },
    { name: 'Tokoroa', slug: 'tokoroa', population: 13600 },
    { name: 'Te Awamutu', slug: 'te-awamutu', population: 13300 },
    { name: 'Cambridge', slug: 'cambridge-nz', population: 20100 },
    { name: 'Morrinsville', slug: 'morrinsville', population: 7900 },
    { name: 'Matamata', slug: 'matamata', population: 8100 },
    { name: 'Te Kuiti', slug: 'te-kuiti', population: 4300 },
    { name: 'Huntly', slug: 'huntly', population: 7900 },
    { name: 'Ngaruawahia', slug: 'ngaruawahia', population: 5900 },
    { name: 'Thames', slug: 'thames-nz', population: 7400 },
    { name: 'Whitianga', slug: 'whitianga', population: 6200 },
    { name: 'Coromandel', slug: 'coromandel', population: 1800 },
    { name: 'Paeroa', slug: 'paeroa', population: 4000 },
    { name: 'Waihi', slug: 'waihi', population: 4700 },
    { name: 'Katikati', slug: 'katikati', population: 5200 },
    { name: 'Te Puke', slug: 'te-puke', population: 9200 },
    { name: 'Mount Maunganui', slug: 'mount-maunganui', population: 22400 },
    { name: 'Papamoa', slug: 'papamoa', population: 26700 },
    { name: 'Bethlehem', slug: 'bethlehem-nz', population: 8900 },
    { name: 'Welcome Bay', slug: 'welcome-bay', population: 5600 },
    { name: 'Opotiki', slug: 'opotiki', population: 9000 },
    { name: 'Kawerau', slug: 'kawerau', population: 7100 },
    { name: 'Murupara', slug: 'murupara', population: 1800 },
    { name: 'Taupo', slug: 'taupo', population: 25200 },
    { name: 'Turangi', slug: 'turangi', population: 3700 },
    { name: 'National Park', slug: 'national-park-nz', population: 300 },
    { name: 'Ohakune', slug: 'ohakune', population: 1100 },
    { name: 'Raetihi', slug: 'raetihi', population: 1000 },
    { name: 'Taihape', slug: 'taihape', population: 1700 },
    { name: 'Bulls', slug: 'bulls', population: 1700 },
    { name: 'Marton', slug: 'marton', population: 4900 },
    { name: 'Feilding', slug: 'feilding', population: 16500 },
    { name: 'Foxton', slug: 'foxton', population: 3100 },
    { name: 'Shannon', slug: 'shannon', population: 1200 },
    { name: 'Otaki', slug: 'otaki', population: 6100 },
    { name: 'Waikanae', slug: 'waikanae', population: 13200 },
    { name: 'Paraparaumu', slug: 'paraparaumu', population: 29000 },
    { name: 'Raumati', slug: 'raumati', population: 7800 },
    { name: 'Plimmerton', slug: 'plimmerton', population: 2900 },
    { name: 'Porirua', slug: 'porirua', population: 59000 },
    { name: 'Tawa', slug: 'tawa', population: 15400 },
    { name: 'Upper Hutt', slug: 'upper-hutt', population: 44100 },
    { name: 'Lower Hutt', slug: 'lower-hutt', population: 107700 },
    { name: 'Eastbourne', slug: 'eastbourne-nz', population: 5100 },
    { name: 'Wainuiomata', slug: 'wainuiomata', population: 18800 },
    { name: 'Petone', slug: 'petone', population: 7300 },
    { name: 'Martinborough', slug: 'martinborough', population: 1500 },
    { name: 'Greytown', slug: 'greytown', population: 2400 },
    { name: 'Featherston', slug: 'featherston', population: 2400 },
    { name: 'Carterton', slug: 'carterton', population: 5800 },
    { name: 'Eketahuna', slug: 'eketahuna', population: 500 },
    { name: 'Pahiatua', slug: 'pahiatua', population: 2500 },
    { name: 'Woodville', slug: 'woodville-nz', population: 1400 },
    { name: 'Dannevirke', slug: 'dannevirke', population: 5500 },
    { name: 'Norsewood', slug: 'norsewood', population: 300 },
    { name: 'Waipukurau', slug: 'waipukurau', population: 4200 },
    { name: 'Waipawa', slug: 'waipawa', population: 2300 },
    { name: 'Havelock North', slug: 'havelock-north', population: 14800 },
    { name: 'Clive', slug: 'clive', population: 2100 },
    { name: 'Te Awanga', slug: 'te-awanga', population: 400 },
    { name: 'Wairoa', slug: 'wairoa', population: 8400 },
    { name: 'Tolaga Bay', slug: 'tolaga-bay', population: 900 },
    { name: 'Te Karaka', slug: 'te-karaka', population: 400 },
    { name: 'Ruatoria', slug: 'ruatoria', population: 900 },
    { name: 'Te Araroa', slug: 'te-araroa', population: 200 },
    { name: 'Hicks Bay', slug: 'hicks-bay', population: 100 },
    { name: 'Te Puia Springs', slug: 'te-puia-springs', population: 150 },
    { name: 'Tikitiki', slug: 'tikitiki', population: 300 },
    { name: 'Te Kaha', slug: 'te-kaha', population: 200 },
    { name: 'Torere', slug: 'torere', population: 100 },
    { name: 'Kutarere', slug: 'kutarere', population: 200 },
    { name: 'Taneatua', slug: 'taneatua', population: 700 },
    { name: 'Edgecumbe', slug: 'edgecumbe', population: 1700 },
    { name: 'Te Teko', slug: 'te-teko', population: 600 },
    { name: 'Awakeri', slug: 'awakeri', population: 300 }
  ]
};
